import { useEffect, useState } from 'react'

import { fetchHomepageCounts, Section } from './service/CopHomePageCountService'

type UseCopHomePageCountResult = {
  sections: Section[]
  selectedSection: string
  setSelectedSection: (value: string) => void
  currentSection: Section | undefined
  isLoading: boolean
}

const useCopHomePageCount = (counttype?: string): UseCopHomePageCountResult => {
  const [sections, setSections] = useState<Section[]>([])
  const [selectedSection, setSelectedSection] = useState<string>(counttype ?? 'KPIsSection')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetchHomepageCounts().then(data => {
      if (data) {
        setSections(data.sections.filter(isKpiWidget))
      }
    }).finally(() => setIsLoading(false))
  }, [])

  const isKpiWidget = (s: Section) => s.widgets.some(w => (w.type || '').trim().toLowerCase() === 'kpi')

  const currentSection = sections.find(s => s.indicator === selectedSection)

  return { sections, selectedSection, setSelectedSection, currentSection, isLoading }
}

export default useCopHomePageCount
